<template>
    <team-layout v-if="teamStore.team">
        <template #createTeam v-if="teamStore.team.hasPermission && teamStore.team.canCreateTeam">
            <div class="card card-app-design mb-4 justify-content-center">
                <div class="card-header">
                    <h3 class="mx-auto">Create A Team</h3>
                </div>
                <div class="card-body">
                    <form>
                        <div class="form-group">
                            <label for="name">
                                Enter Team Name
                            </label>
                            <input type="text" class="form-control " name="name" id="name" v-model="teamName"/>
                            <div v-if="createTeamValidate.teamName.$error" class="error mt-1 text-warning">
                                Team Name {{ createTeamValidate.teamName.$errors[0].$message.toLowerCase() }}
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-block" @click="createTeam"  v-if="teamStore.team.canCreateTeam">Create Team</button>
                    </form>
                </div>
            </div>
        </template>
        <template #send_invite>
            <add-team-member></add-team-member>
        </template>
    </team-layout>
    <div v-if="userStore.user.isTeamMember" class="row mx-auto">
        <div v-if="userStore.user.teams.length > 0" v-for="team in userStore.user.teams" class="col-lg-4 col-md-6 col-12">
            <div class="card card-developer-meetup">
                <div class="card-body">
                    <div class="media">
                        <div class="avatar bg-light-primary rounded mr-1">
                            <div class="avatar-content">
                                <i data-feather="user" class="avatar-icon font-medium-3"></i>
                            </div>
                        </div>
                        <div class="users">
                            <h6 class="mb-0">Team Owner:
                                {{ team.admin.firstname }}
                            </h6>
                            <small>
                                {{ team.admin.email }}
                            </small>
                        </div>
                    </div>
                    <div class="media">
                        <div class="avatar bg-light-primary rounded mr-1 ">
                            <div class="avatar-content">
                                <i data-feather="navigation" class="avatar-icon font-medium-3"></i>
                            </div>
                        </div>
                        <div class="users">
                            <h6 class="card-text mb-0">Click Link To Access Team: </h6>
                            <small>
                                {{ team.name }}
                            </small>
                        </div>
                    </div>
                    <div class="mt-1">
                        <button @click="leaveTeam(team.id)" type="button" class="btn btn-primary d-inline-block">Leave Team</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row mx-auto text-center">
            <h4 v-if="userStore.user.isBusinessUser" class="mb-0 text-danger">You Have Not Created Any Teams Yet.</h4>
            <div v-else >
                <h3 class="mb-0 text-warning text-center">
                    You're Not Apart of Any Teams Yet.
                </h3>
                <div class="col-lg-12 col-md-12 col-12">
                    <div class="card">
                        <div class="row p-4 text-center">
                            <div class="col-12">
                                <h4 class="fw-bolder">
                                    {{ localizationStore.translate('team.invite.member.title') }}
                                </h4>
                                <div class="d-flex justify-content-center text-left">
                                    <div>
                                        <label class="form-label" for="invite-code">
                                            {{ localizationStore.translate('team.invite.member.input.first.label') }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': joinTeamValidate.inviteCode.$error }"
                                            name="invite-code"
                                            id="invite-code"
                                            v-model="inviteCode"
                                        />
                                        <span v-if="joinTeamValidate.inviteCode.$error" class="invalid-feedback" role="alert">
                                            <strong>Field is Required</strong>
                                        </span>
                                    </div>
                                    <button type="button" class="btn btn-primary waves-effect waves-float waves-light mt-auto ml-1" v-on:click="joinTeam">
                                        {{ localizationStore.translate('team.invite.member.button.text') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import TeamLayout from '../layouts/TeamLayout.vue'
import { useTeamStore } from '../../../stores/TeamStore.js'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../stores/UserStore.js'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AddTeamMember from '../layouts/AddTeamMember'
import Swal from 'sweetalert2'

import axios from 'axios'
export default{
    components:{
        TeamLayout,
        AddTeamMember
    },
    setup() {
        const inviteCode = ref(null),
        teamName = ref(null);
        return {
            localizationStore: useLocalizationStore(),
            teamStore: useTeamStore(),
            userStore: useUserStore(),
            inviteCode,
            teamName,
            createTeamValidate: useVuelidate(
                {
                    teamName: {
                        required
                    },
                },
                {
                    teamName
                }
            ),
            joinTeamValidate: useVuelidate(
                {
                    inviteCode: {
                        required
                    }
                },
                {
                    inviteCode
                }
            ),
        }
    },
    mounted(){
        this.userStore.fetchUser();
        this.userStore.fetchCheckValidUserDispute();
    },
    methods:{
        createTeam(){
            this.createTeamValidate.$validate();
            if(this.createTeamValidate.$error <= 0 ){
                let params = {
                    name:this.teamName
                };
                const route = this.$router.resolve(
                    {
                        name: 'store-teams'
                    }
                );
                axios.post(route.href,params).then(({data})=>{
                    if(data.error != true){
                        toastr.success(data.message,"Team Success")
                        this.teamStore.fetchTeam();
                    }
                }).catch(error=>{
                    let errors = this.getError(error)
                    for (const key in errors) {
                        if (Object.hasOwnProperty.call(errors, key)) {
                            const element = errors[key];
                            return toastr.error(`${element}`,'Team Error');
                        }
                    }
                });
            }
        },
        getError(error){
            const errorMsg = "";

            if (!error.response) {
                return errorMsg;
            }
            if (error.response.data && error.response.data.errors) {
                return error.response.data.errors;
            }
            return errorMsg;
        },
        leaveTeam(teamId) {
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: 'You will not be able to re-join the team.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Leave Team',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'teams-users-leave',
                            params: {
                                team: teamId,
                                user: $this.userStore.user.id
                            }
                        }
                    );
                    axios.post(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                        setTimeout(() => {window.location.reload();}, 3000)
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        async joinTeam() {
            const isValid = await this.joinTeamValidate.$validate(),
            $this = this;
            if (isValid) {
                const route = $this.$router.resolve(
                    {
                        name: 'team-member-join',
                    }
                );
                axios.post(
                    route.href,
                    {
                        invite_code: $this.inviteCode
                    }
                )
                .then(function (response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {window.location.reload();}, 3000)
                })
                .catch(function (error) {
                    toastr.error(error.response.statusText, 'Error!');
                });
            }
        },
    }
}
</script>
